import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo_pop from '../assets/images/logo-pop.png';
import DashboardProfileHeader from '../components/DashboardProfileHeader';

import * as globals from '../globals.js';
import ApiService from '../services/ApiService';
import NotificationService from '../services/NotificationService';
import { useDispatch } from 'react-redux';
export default class Profil_ja extends Component {
    userData = null;
    
    constructor() {
        super();
        this.apiService = ApiService.getInstance();
        this.notificationService = NotificationService.getInstance();
        this.state = { obligatoryDataProvided: false, loading: false };
        const today = Date.now();

        this.state = {
            onOfmenu: 'dashboard__btn-chevron',
            onOfopacity: 'dashboard__submenu',
            onOfmenu2: 'dashboard__btn-chevron rotate-180',
            onOfopacity2: 'dashboard__submenu max-height-0 opacity-0',
        };
    }

    formatData(data){
        if(data && data !== null) {
            let newData = data.split(' ');
            let newDatapase = newData[0].split('/');
            return  newDatapase[1] + '.' + newDatapase[0] + '.' + newDatapase[2]
        } else {
            return null
        }
    }

    svgClick(key) {
        if (key === 1) {
            if (this.state.onOfmenu === 'dashboard__btn-chevron') {
                this.setState({ onOfmenu: 'dashboard__btn-chevron rotate-180' });
                this.setState({ onOfopacity: 'dashboard__submenu max-height-0 opacity-0' });
            } else {
                this.setState({ onOfmenu: 'dashboard__btn-chevron' });
                this.setState({ onOfopacity: 'dashboard__submenu' });
            }
        } else {
            if (this.state.onOfmenu2 === 'dashboard__btn-chevron') {
                this.setState({ onOfmenu2: 'dashboard__btn-chevron rotate-180' });
                this.setState({ onOfopacity2: 'dashboard__submenu max-height-0 opacity-0' });
            } else {
                this.setState({ onOfmenu2: 'dashboard__btn-chevron' });
                this.setState({ onOfopacity2: 'dashboard__submenu' });
            }
        }
    }

    componentDidMount() {
        this.loadData((success) => {
            if (typeof success === 'boolean' && success) {
                this.setState({ obligatoryDataProvided: true });
            } else {
                // problem podczas pobierania danych użytkownika
                this.notificationService.showError();
            }
        });
    }

    loadData(callback) {
        this.setState({ loading: true });
        this.apiService.apiGet('UserGet', (response) => {
            this.setState({ loading: false });
            if (response.success) {
                this.userData = response.data;
                localStorage.setItem('userData', JSON.stringify(response.data));
                localStorage.setItem('usersID', response.data.usersID);
                if (typeof callback === 'function') callback(true);
            } else {
                if (typeof callback === 'function') callback(false);
            }
        });
    }

    render() {
        return (
            <>
                
                         <div className="dashboard__content">
                            <main className="responsive-padding">
                                <div className="dashboard__heading">
                                    <svg
                                        width="32"
                                        height="32"
                                        viewBox="0 0 32 32"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M16 8C15.0111 8 14.0444 8.29325 13.2222 8.84265C12.3999 9.39206 11.759 10.173 11.3806 11.0866C11.0022 12.0002 10.9031 13.0055 11.0961 13.9755C11.289 14.9454 11.7652 15.8363 12.4645 16.5355C13.1637 17.2348 14.0546 17.711 15.0246 17.9039C15.9945 18.0969 16.9998 17.9978 17.9134 17.6194C18.8271 17.241 19.6079 16.6001 20.1574 15.7779C20.7068 14.9556 21 13.9889 21 13C21 11.6739 20.4732 10.4021 19.5355 9.46447C18.5979 8.52678 17.3261 8 16 8Z" />
                                        <path d="M16 2C13.2311 2 10.5243 2.82109 8.22202 4.35943C5.91973 5.89777 4.12532 8.08427 3.06569 10.6424C2.00607 13.2006 1.72882 16.0155 2.26901 18.7313C2.80921 21.447 4.14258 23.9416 6.10051 25.8995C8.05845 27.8574 10.553 29.1908 13.2687 29.731C15.9845 30.2712 18.7994 29.9939 21.3576 28.9343C23.9157 27.8747 26.1022 26.0803 27.6406 23.778C29.1789 21.4757 30 18.7689 30 16C29.9958 12.2883 28.5194 8.72977 25.8948 6.10518C23.2702 3.48059 19.7117 2.00423 16 2ZM23.992 24.926C23.9721 23.6143 23.4377 22.363 22.5039 21.4416C21.5702 20.5202 20.3118 20.0025 19 20H13C11.6882 20.0025 10.4298 20.5202 9.4961 21.4416C8.56235 22.363 8.02794 23.6143 8.00801 24.926C6.19457 23.3067 4.91574 21.1749 4.34084 18.8127C3.76594 16.4505 3.92211 13.9693 4.78864 11.6979C5.65518 9.42637 7.19123 7.47167 9.19338 6.09257C11.1955 4.71347 13.5693 3.97503 16.0005 3.97503C18.4317 3.97503 20.8055 4.71347 22.8076 6.09257C24.8098 7.47167 26.3458 9.42637 27.2124 11.6979C28.0789 13.9693 28.2351 16.4505 27.6602 18.8127C27.0853 21.1749 25.8064 23.3067 23.993 24.926H23.992Z" />
                                    </svg>
                                    <h2 className="h2">Ja</h2>
                                </div>

                                {this.renderUserData()}
                            </main>
                        </div> */
                    
            </>
        );
    }

    renderUserData() {
        this.loadData();
        if (!this.state.loading && this.state.obligatoryDataProvided) {
            return (
                <div className="margin-top-32">
                    <div className="form__row">
                        <h5 className="form__label">Imię</h5>
                        <span id="me-fname" className="text-large fw-700">
                            {this.userData.firstName}
                        </span>
                    </div>
                    <div className="form__row">
                        <h5 className="form__label">Nazwisko</h5>
                        <span id="me-lname" className="text-large fw-700">
                            {this.userData.lastName}
                        </span>
                    </div>
                    <div className="form__row">
                        <h5 className="form__label">Płeć</h5>
                        <span id="me-gender" className="text-large fw-700">
                            {(this.userData.genderDVID === 1)
                                ? 'Mężczyzna'
                                : (this.userData.genderDVID === 2)
                                ? 'Kobieta'
                                : 'Inna'}
                        </span>
                    </div>
                    <div className="form__row">
                        <h5 className="form__label">PESEL</h5>
                        <span id="me-pesel" className="text-large fw-700">
                            {this.userData.pesel}
                        </span>
                    </div>
                    <div className="form__row">
                        <h5 className="form__label">Data urodzenia</h5>
                        <span id="me-bday" className="text-large fw-700">
                        {this.formatData(this.userData.dateOfBirdth)}
                             
                        </span>
                    </div>
                    <div className="form__row">
                        <h5 className="form__label">Ulica</h5>
                        <span id="me-street" className="text-large fw-700">
                            {this.userData.street}
                        </span>
                    </div>
                    <div className="form__row form__row--home-numbers">
                        <div>
                            <h5 className="form__label">Nr domu</h5>
                            <span id="me-house" className="text-large fw-700">
                                {this.userData.building}
                            </span>
                        </div>
                        <div>
                            <h5 className="form__label">Nr mieszkania</h5>
                            <span id="me-flat" className="text-large fw-700">
                                {this.userData.flat}
                            </span>
                        </div>
                    </div>
                    <div className="form__row">
                        <h5 className="form__label">Miejscowość</h5>
                        <span id="me-city" className="text-large fw-700">
                            {this.userData.city}
                        </span>
                    </div>
                    <div className="form__row">
                        <h5 className="form__label">Kod pocztowy</h5>
                        <span id="me-zipcode" className="text-large fw-700">
                            {this.userData.postalCode}
                        </span>
                    </div>
                    <div className="form__row">
                        <h5 className="form__label">E-mail</h5>
                        <span id="me-email" className="text-large fw-700">
                            {this.userData.email}
                        </span>
                    </div>
                    <div className="form__row">
                        <h5 className="form__label">Nr telefonu</h5>
                        <span id="me-phone" className="text-large fw-700">
                            {this.userData.phone}
                        </span>
                    </div>

                    <div className="form__row">
                        <h5 className="form__label">Hasło logowania</h5>

                        <NavLink
                            to="/login_zmien_haslo"
                            className="btn-secondary btn-secondary--small margin-top-8"
                        >
                            Zmień hasło
                        </NavLink>
                    </div>

                    <div className="form__row">
                        <span className="checkbox-group">
                            <input
                                type="checkbox"
                                id="edit-related-agreement"
                                name="edit-related-agreement"
                                className="form__checkbox"
                                checked={this.userData.personalDataProcessingConsent === true}
                                disabled
                            />
                            <label
                                htmlFor="edit-related-agreement"
                                className="form__label--checkbox consent_checkbox"
                            >
                                <div>Akceptuję Klauzulę informacyjną RODO:</div>
                                <ul>
                                    {globals.USER_CONSENTS.map((consent) => (
                                        <li>{consent}</li>
                                    ))}
                                </ul>
                            </label>
                        </span>

                        <p className="checkbox-group">
                            <input
                                type="checkbox"
                                id="regulations"
                                name="regulations"
                                className="form__checkbox"
                                checked={this.userData.personalDataProcessingConsent === true}
                                disabled
                            />
                            <label htmlFor="regulations" className="form__label--checkbox">
                                Akceptuję{' '}
                                <a
                                    href={globals.TERMS_URL}
                                    className="text-link"
                                    target="_blank"
                                    rel="noopener"
                                >
                                    Regulamin
                                </a>
                            </label>
                        </p>
                    </div>
                </div>
            );
        } else {
            return <></>;
        }
    }
}
